var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"launcher",on:{"click":function($event){return _vm.launch(_vm.launcher)}}},[_c('img',{attrs:{"src":_vm.launcher.secondary_image_url}}),_c('h3',[_vm._v(_vm._s(_vm.launcher.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }